import React from 'react';
import classNames from 'classnames';
import { ReactComponent as EmptyIcon } from './SearchEmpty.svg';
import st from './EmptyPanel.module.scss';

interface IEmptyPanelProps extends React.HTMLAttributes<HTMLDivElement> {
	text?: string;
	children?: React.ReactNode;
	isRow?: boolean;
	hideIcon?: boolean;
}

const EmptyPanel: React.FC<IEmptyPanelProps> = ({
	isRow = true,
	hideIcon = false,
	children,
	text = '',
	className,
	...otherProps
}) => {
	return (
		<div
			className={classNames('emptypanel', st.emptypanel, className, {
				[st.isRow]: isRow,
			})}
			{...otherProps}
		>
			{!hideIcon && (
				<div className={st.emptypanel_icon}>
					<EmptyIcon />
				</div>
			)}
			<div className={st.emptypanel_text}>
				{children ? children : text}
			</div>
		</div>
	);
};

export default EmptyPanel;
